/* Vocalise theme — interactions */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var items = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--d')) {
        var group = el.closest('[data-reveal-group]');
        if (group) {
          var siblings = Array.prototype.slice.call(group.querySelectorAll('[data-reveal]'));
          el.style.setProperty('--d', (siblings.indexOf(el) * 90) + 'ms');
        } else {
          el.style.setProperty('--d', ((i % 4) * 70) + 'ms');
        }
      }
      io.observe(el);
    });
  }

  /* ---------- header ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var last = 0;
    var trigger = header.offsetHeight;

    function onScroll() {
      var y = window.pageYOffset;
      header.classList.toggle('header--stuck', y > trigger);
      header.classList.toggle('header--hidden', y > trigger * 3 && y > last && !document.body.classList.contains('nav-open'));
      last = y;
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

        var burger = header.querySelector('[data-burger]');

    function setNav(open) {
      document.body.classList.toggle('nav-open', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (burger) {
      burger.addEventListener('click', function () {
        setNav(!document.body.classList.contains('nav-open'));
      });
    }

    // the cross, and every link in the panel, close it
    document.querySelectorAll('[data-nav-close]').forEach(function (el) {
      el.addEventListener('click', function () { setNav(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setNav(false);
    });
  }

  /* ---------- accordions ---------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-accordion-btn]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      if (btn.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function once() {
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', once);
          });
        }
      });
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', 'false');
        });
        thumb.setAttribute('aria-current', 'true');
        main.style.opacity = '0';
        window.setTimeout(function () {
          main.src = thumb.dataset.full;
          main.srcset = thumb.dataset.fullSrcset || '';
          main.alt = thumb.dataset.alt || '';
          main.style.opacity = '1';
        }, 180);
      });
    });
  }

  /* ---------- quantity ---------- */
  function initQty(scope) {
    (scope || document).querySelectorAll('[data-qty]').forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.step === 'up' ? 1 : -1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- variants ---------- */
  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var dataEl = document.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var submit = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-price]');
    var comparePriceEl = document.querySelector('[data-compare-price]');
    var money = form.dataset.moneyFormat || '${{amount}}';

    function format(cents) {
      var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money.replace(/\{\{\s*amount[^}]*\}\}/, value);
    }

    function selectedOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return !val || v.options[i] === val; });
      });

      if (!match) {
        submit.setAttribute('aria-disabled', 'true');
        submit.textContent = 'Unavailable';
        return;
      }

      idInput.value = match.id;
      if (priceEl) priceEl.textContent = format(match.price);
      if (comparePriceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          comparePriceEl.textContent = format(match.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      submit.setAttribute('aria-disabled', match.available ? 'false' : 'true');
      submit.textContent = match.available ? (submit.dataset.label || 'Add to cart') : 'Sold out';

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    }

    form.addEventListener('change', update);
    update();
  }


/* ---------- founder video: play / pause ---------- */
  function initVideos(scope) {
    (scope || document).querySelectorAll('[data-video-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      var wrap = btn.parentNode;
      var video = wrap.querySelector('[data-video]');
      var embed = wrap.querySelector('[data-video-embed]');
      if (!video && !embed) return;

      function paint(playing) {
        btn.setAttribute('data-playing', playing ? 'true' : 'false');
        btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }

      if (video) {
        var sync = function () { paint(!video.paused && !video.ended); };

        btn.addEventListener('click', function () {
          if (video.paused) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        video.addEventListener('ended', sync);
        sync();
        window.setTimeout(sync, 600);
        return;
      }

      // YouTube / Vimeo: drive the embed with postMessage so our own button stays in charge
      var kind = embed.getAttribute('data-video-embed');
      var playing = embed.getAttribute('data-autoplay') === 'true';
      paint(playing);

      btn.addEventListener('click', function () {
        var win = embed.contentWindow;
        if (!win) return;

        if (kind === 'youtube') {
          win.postMessage(JSON.stringify({
            event: 'command',
            func: playing ? 'pauseVideo' : 'playVideo',
            args: []
          }), '*');
        } else {
          win.postMessage(JSON.stringify({ method: playing ? 'pause' : 'play' }), '*');
        }

        playing = !playing;
        paint(playing);
      });
    });
  }

  /* ---------- cart drawer + ajax add ---------- */
  var Cart = {
    drawer: null,
    overlay: null,

    open: function () {
      if (!this.drawer) return;
      this.drawer.setAttribute('aria-hidden', 'false');
      this.overlay.classList.add('is-on');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.setAttribute('aria-hidden', 'true');
      this.overlay.classList.remove('is-on');
      document.body.style.overflow = '';
    },
    refresh: function () {
      var self = this;
      return fetch(window.Theme.routes.cart + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-drawer-inner]');
          var target = self.drawer && self.drawer.querySelector('[data-drawer-inner]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
          initQty(self.drawer);
          return fetch(window.Theme.routes.cart + '.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        })
        .catch(function () {});
    },

        /* Shopify only answers with JSON on the .js endpoints. /cart/add returns a
       full HTML page, which is what produced the "Unexpected token '<'" error. */
    ajaxUrl: function (url) {
      return /\.js(\?|$)/.test(url) ? url : url + '.js';
    },

    add: function (form, button) {
      var self = this;
      var original = button.textContent;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Adding…';

      fetch(self.ajaxUrl(window.Theme.routes.cartAdd), {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add');
            return data;
          });
        })
        .then(function () {
          button.textContent = 'Added';
          return self.refresh().then(function () { self.open(); });
        })
        .catch(function (err) {
          if (window.console) console.error('[cart]', err);
          /* keep the button label short — the raw error belongs in the console */
          button.textContent = (err && err.message && err.message.length < 40)
            ? err.message
            : 'Could not add';
        })
        .finally(function () {
          window.setTimeout(function () {
            button.textContent = original;
            button.setAttribute('aria-disabled', 'false');
          }, 1400);
        });
    },

    change: function (line, quantity) {
      var self = this;
      fetch(self.ajaxUrl(window.Theme.routes.cartChange), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function () { return self.refresh(); })
        .catch(function () {});
    },

    init: function () {
      var self = this;
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-overlay]');
      if (!this.drawer) return;

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener) { e.preventDefault(); self.refresh().then(function () { self.open(); }); return; }
        if (e.target.closest('[data-cart-close]') || e.target.closest('[data-overlay]')) self.close();

        var remove = e.target.closest('[data-cart-remove]');
        if (remove) { e.preventDefault(); self.change(remove.dataset.cartRemove, 0); }
      });

      document.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cart-qty]');
        if (input) self.change(input.dataset.cartQty, input.value);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });

      document.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-product-form]');
        if (!form) return;
        var button = form.querySelector('[data-add-button]');
        if (!button || button.getAttribute('aria-disabled') === 'true') return;
        e.preventDefault();
        self.add(form, button);
      });
    }
  };

  function revealEverything() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function boot() {
    // Reveal runs first and alone, so a failure further down can never hide content.
    try { initReveal(); } catch (e) { revealEverything(); }

        [initHeader, initAccordions, initGallery, initQty, initVariants, initVideos, function () { Cart.init(); }]
      .forEach(function (fn) {
        try { fn(); } catch (e) { if (window.console) console.error('[theme]', e); }
      });

    // Last-resort net: anything still hidden after 4s gets shown.
    window.setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) {
        var box = el.getBoundingClientRect();
        if (box.top < window.innerHeight * 1.5) el.classList.add('is-in');
      });
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
